import ParticlesComponent from './components/ParticlesComponent';
import NavbarComponent from './components/NavbarComponent';


function App() {

  return (
    <div className='App'>
      <NavbarComponent />
      <ParticlesComponent />
    </div>
  );
}

export default App;
